module.exports = __webpack_public_path__ + "static/media/md-repeat.2f28dffe.svg";